document.addEventListener('DOMContentLoaded', () => {
  const sockVariantId = 46920533180468;

  const handleGiftLogicBeforeCheckout = async () => {
    const checkoutBtn = document.querySelector('[name="checkout"]');
    if (!checkoutBtn || checkoutBtn.dataset.giftHandlerAttached) return;
    checkoutBtn.dataset.giftHandlerAttached = 'true';

    checkoutBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      try {
        // 장바구니 가져오기
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const subtotal = cart.items_subtotal_price / 100;
        const giftItem = cart.items.find(item => item.variant_id === sockVariantId);

        // 무료 기프트 상품의 재고 상태 확인
        const variantRes = await fetch(`/variants/${sockVariantId}.js`);
        const variant = await variantRes.json();
        const giftAvailable = variant?.available;

        // 👉 조건 1: $50 미만 && gift 있음 → 제거
        if (subtotal < 50 && giftItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
          });
          return setTimeout(() => window.location.href = '/checkout', 500);
        }

        // 👉 조건 2: $50 이상 && gift 있음 && 품절 → 제거
        if (subtotal >= 50 && giftItem && !giftAvailable) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
          });
          return setTimeout(() => window.location.href = '/checkout', 500);
        }

        // 👉 조건 3: $50 이상 && gift 없음 && 재고 있음 → 추가
        if (subtotal >= 50 && !giftItem && giftAvailable) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: sockVariantId, quantity: 1 }),
          });
          return setTimeout(() => window.location.href = '/checkout', 500);
        }

        // 그 외 → 그냥 checkout 이동
        window.location.href = '/checkout';

      } catch (err) {
        console.error('Gift logic error:', err);
        window.location.href = '/checkout';
      }
    });
  };

  // 실행 및 동적 DOM 반영 감지
  handleGiftLogicBeforeCheckout();
  const observer = new MutationObserver(() => handleGiftLogicBeforeCheckout());
  observer.observe(document.body, { childList: true, subtree: true });
});
